import type { StyleConfig } from "@chakra-ui/theme-tools"

/**
 * Component style overrides.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/v1/packages/theme/src/components/heading.ts
 */
export const Heading: StyleConfig = {
  baseStyle: {
    fontFamily: "heading",
    fontWeight: 600,
  },
  sizes: {
    h1: {
      fontSize: ["h3", null, null, "h1"],
      lineHeight: 1.35,
      letterSpacing: "tight",
    },
    h2: {
      fontSize: ["h3", null, null, "h2"],
      lineHeight: 1.35,
      letterSpacing: "tight",
    },
    h3: {
      fontSize: ["h4", null, null, "h3"],
      lineHeight: 1.43,
    },
    h4: {
      fontSize: ["h5", null, null, "h4"],
      lineHeight: 1.42,
    },
    h5: {
      fontSize: "h5",
      lineHeight: 1.6,
    },
    h6: {
      fontSize: 14,
      lineHeight: 1.6,
    },
    "4xl": {
      fontSize: ["6xl", "6xl", "6xl", "7xl"],
      lineHeight: 1,
    },
    "3xl": {
      fontSize: ["5xl", "5xl", "5xl", "6xl"],
      lineHeight: 1,
    },
    "2xl": {
      fontSize: ["4xl", "4xl", "4xl", "5xl"],
      lineHeight: [1.2, 1.2, 1.2, 1],
    },
    xl: {
      fontSize: ["3xl", "3xl", "3xl", "4xl"],
      lineHeight: [1.33, 1.33, 1.33, 1.2],
    },
    lg: {
      fontSize: ["2xl", "2xl", "2xl", "3xl"],
      lineHeight: [1.33, 1.33, 1.33, 1.2],
    },
    md: { fontSize: "xl", lineHeight: 1.2 },
    sm: { fontSize: "md", lineHeight: 1.2 },
    xs: { fontSize: "sm", lineHeight: 1.2 },
  },
  defaultProps: {
    size: "xl",
  },
}
